<template>
  <section class="about-section section-padding">
    <div class="container">
      <div class="row align-items-center" :class="vars.isReversedBool ? 'flex-row-reverse' : ''">
        <div class="col-xl-6 col-lg-6">
          <div class="tw-w-full">
            <iframe
              v-if="!vars.isPopupBool && vars.videoUrl"
              class="tw-w-full tw-object-cover"
              :src="vars.videoUrl"
              frameborder="0"
              allowfullscreen
              :style="vars.isVerticalBool ? 'aspect-ratio:5/8' : 'aspect-ratio:16/9'"
            ></iframe>

            <LibraryImage
              v-else-if="vars.photoImage && !vars.videoUrl"
              :src="vars.photoImage"
              :w-ratio="vars.isVerticalBool ? 9 : 645"
              :h-ratio="vars.isVerticalBool ? 16 : 430"
            />

            <div
              v-else-if="vars.photoImage && vars.videoUrl && vars.isPopupBool"
              class="tw-relative tw-w-full"
              @click="isVisible = true"
            >
              <button class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2">
                <svg width="80" height="80" viewBox="0 0 162 162" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="81" cy="81" r="81" fill="white" />
                  <polygon points="65,45 115,81 65,117" fill="black" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6">
          <div class="about-content-wrapper wow fadeInUp animated" data-wow-delay=".2s">
            <div class="section-title">
              <h2>
                <svg
                  v-if="vars.isVisibleBool"
                  width="1em"
                  height="52"
                  viewBox="0 0 41 47"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0"
                  style="display: inline"
                >
                  <rect width="40.9678" height="40.9678" fill="#E4002B" />
                  <circle cx="12.7821" cy="4.69764" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="4.69764" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="9.94151" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="15.2946" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="15.2946" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="20.5385" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="25.8916" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="25.8916" r="2.18495" fill="white" />
                  <circle cx="36.161" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="20.6478" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="5.13465" cy="31.1355" r="2.18495" fill="white" />
                  <circle cx="12.7821" cy="36.4886" r="2.18495" fill="white" />
                  <circle cx="28.5136" cy="36.4886" r="2.18495" fill="white" /></svg
                ><span v-if="vars.isVisibleBool">&nbsp;</span>{{ vars.titleText }}
              </h2>
            </div>
            <div class="p-animation mb-4">
              <p>{{ vars.descriptionText }}</p>
            </div>
            <div class="tw-grid tw-gap-x-10 tw-gap-y-2 tw-pt-1 sm:tw-mr-auto sm:tw-grid-cols-2">
              <div class="tw-flex tw-flex-col tw-gap-y-2">
                <div
                  v-if="featuresColumns1"
                  v-for="(feature, index) in featuresColumns1"
                  :key="index"
                  class="tw-flex tw-items-center tw-gap-3"
                >
                  <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.9426 0.942617L6.19262 9.69262C6.13456 9.75082 6.06559 9.797 5.98966 9.82851C5.91373 9.86002 5.83233 9.87624 5.75012 9.87624C5.66791 9.87624 5.58651 9.86002 5.51058 9.82851C5.43464 9.797 5.36567 9.75082 5.30762 9.69262L0.307617 4.69262L1.19262 3.80762L5.75012 8.36637L14.0589 0.0576172L14.9426 0.942617Z"
                      fill="#2b2b2b"
                    />
                  </svg>

                  <h5 class="!tw-text-black">{{ feature.title }}</h5>
                </div>
              </div>
              <div class="tw-flex tw-flex-col tw-gap-y-2">
                <div
                  v-if="featuresColumns2"
                  v-for="(feature, index) in featuresColumns2"
                  :key="index"
                  class="tw-flex tw-items-center tw-gap-3"
                >
                  <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.9426 0.942617L6.19262 9.69262C6.13456 9.75082 6.06559 9.797 5.98966 9.82851C5.91373 9.86002 5.83233 9.87624 5.75012 9.87624C5.66791 9.87624 5.58651 9.86002 5.51058 9.82851C5.43464 9.797 5.36567 9.75082 5.30762 9.69262L0.307617 4.69262L1.19262 3.80762L5.75012 8.36637L14.0589 0.0576172L14.9426 0.942617Z"
                      fill="#2b2b2b"
                    />
                  </svg>

                  <h5 class="!tw-text-black">{{ feature.title }}</h5>
                </div>
              </div>
            </div>
            <nuxt-link :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText} tw-mt-7 tw-w-auto tw-self-start`">{{
              vars.buttonLabelText
            }}</nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  mixins: [ComponentMixin],

  data() {
    return {};
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    featuresColumns1() {
      return this.groupedVariables.column_1_features;
    },

    featuresColumns2() {
      return this.groupedVariables.column_2_features;
    },
  },

  methods: {
    isExternalLink(url: string) {
      return url.includes('http');
    },
  },
});
</script>
